// O botao Acoes do cabecalho das telas do menu Cobranca que o exibem (hoje so
// a Carteira). Fica fora da tela para que outra que venha a precisar dele use
// o helper em vez de recopiar o objeto.
//
// Reune as operacoes de cabecalho num so menu: as duas importacoes por
// planilha e o disparo manual da regua. A tela repassa o `setModal`, o
// `reload` (a listagem recarrega ao fim da operacao) e o `user`, que decide
// quais opcoes aparecem:
//
//   const buttons = useMemo(
//     () => [buildActionsButton({ setModal, reload, user })],
//     [setModal, reload, user]
//   );
//
// O `icon` do botao e nome de SVG em `public/icons/`, e nao de Material
// Symbols — so as `options` usam Material Symbols.
export const buildActionsButton = ({ setModal, reload, user }) => ({
  label: 'Ações',
  icon: 'more',
  color: 'blue',
  border: true,
  options: [
    {
      label: 'Importar carteira',
      icon: 'table_view',
      description: 'Cadastra os títulos a partir da planilha da carteira',
      action: () => setModal({ type: 'importar_cobranca', reload }),
    },
    {
      label: 'Importar baixa',
      icon: 'price_check',
      description: 'Baixa parcelas já cadastradas com a planilha de pagamentos',
      action: () => setModal({ type: 'baixa_lote_cobranca', reload }),
    },
    // A regua nao dispara mais sozinha. So quem tem a flag `executar_regua`
    // aciona — nem o `administrador` dispensa, o backend responde 403 —, entao
    // a regra de exibicao e so a flag, comparada com `true` estrito.
    ...(user?.executar_regua === true
      ? [
          {
            label: 'Executar régua',
            icon: 'send',
            description:
              'Envia por WhatsApp os avisos agendados, após conferir o resumo',
            action: () => setModal({ type: 'billing_run_dunning', reload }),
          },
        ]
      : []),
  ],
});
